import { apiPaths } from '../config/api-paths.js';
import request from '../utils/request.js';
import { stringifyQuery } from '../utils/query.js';
import type {
  ApiResponse,
  RequestResult,
  MainSession,
  MutablePayload,
} from '../types/domain.js';

export async function getSession(): Promise<RequestResult<MainSession>> {
  return request<MainSession>(apiPaths.mainSession);
}

export async function registerMessage(
  params: MutablePayload,
): Promise<RequestResult<ApiResponse<unknown>>> {
  return request<ApiResponse<unknown>>(apiPaths.registerMessage, {
    method: 'POST',
    body: params,
  });
}

export async function checkSchoolName(
  params: Readonly<Record<string, unknown>>,
): Promise<RequestResult<ApiResponse<unknown>>> {
  return request<ApiResponse<unknown>>(`${apiPaths.checkSchoolName}?${stringifyQuery(params)}`);
}

export async function checkSchoolNameByName(
  params: Readonly<Record<string, unknown>>,
): Promise<RequestResult<ApiResponse<unknown>>> {
  return request<ApiResponse<unknown>>(
    `${apiPaths.checkSchoolNameByName}?${stringifyQuery(params)}`,
  );
}

export async function checkSlug(
  params: Readonly<Record<string, unknown>>,
): Promise<RequestResult<ApiResponse<unknown>>> {
  return request<ApiResponse<unknown>>(`${apiPaths.checkSlug}?${stringifyQuery(params)}`);
}
